export const EUROPEAN_MARKET_HISTORICAL_PICTURE_CHART_DATA_KEYS = [
	{
		name: "units",
		translation: "pages.pillar.pillar2.europeanMarketHistoricalPicture.blocks.chart.dataKeys.units",
		color: "#4290ce",
		showLabel: true,
	},
];